var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-container",
        { staticClass: "mt-4 mb-4" },
        [
          _c(
            "div",
            {
              staticClass:
                "col-md-8 mt-4 d-flex align-items-start justify-content-between"
            },
            [
              _c("back-arrow", {
                attrs: { title: _vm.$t("my.favorites.title") }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isLoading
            ? _c(
                "transition-group",
                {
                  attrs: {
                    appear: "",
                    name: "listCustomTransition",
                    tag: "div"
                  }
                },
                [
                  _c(
                    "div",
                    { key: "homePlaceHolder-draft", staticClass: "mt-4" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "other-annonces card-container row row-cards-annonces"
                        },
                        [
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading
            ? _c(
                "transition-group",
                { attrs: { name: "listCustomTransition" } },
                [
                  _vm.favorites.length > 0
                    ? [
                        _c(
                          "div",
                          {
                            key: "favorites-list",
                            staticClass: "favorite-annonces cards-container"
                          },
                          _vm._l(_vm.favorites, function(annonce) {
                            return _c("annonce-card-image-left", {
                              key: annonce.serverId,
                              staticClass: "cursor-pointer",
                              attrs: { annonce: annonce, "from-my-annonce": "" }
                            })
                          }),
                          1
                        )
                      ]
                    : [
                        _c(
                          "div",
                          {
                            key: "favorites-empty-list",
                            staticClass: "card-container"
                          },
                          [
                            _c("div", { staticClass: "d-flex" }, [
                              _c("div", { staticClass: "p-3" }, [
                                _c("img", {
                                  staticClass: "empty-state-img-home",
                                  attrs: {
                                    src: require("@/assets/images/b122/img-confused.png"),
                                    alt: "no result"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "empty-state-text" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "my.favorites.empty.state.description"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6441b37e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6441b37e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/MyFavorites.vue
// module id = xvpd
// module chunks = 0